import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  GetMaintanceStatusGQL,
  MaintanceStatusReponse
} from '@cpd-app/generated';

@Injectable({ providedIn: 'root' })
export class MaintanceService {
  constructor(private getMaintanceStatusGQL: GetMaintanceStatusGQL) {}

  public getMaintanceStatus(): Observable<MaintanceStatusReponse> {
    return this.getMaintanceStatusGQL
      .fetch()
      .pipe(
        map(
          (result) => result.data?.getMaintanceStatus as MaintanceStatusReponse
        )
      );
  }
}
